let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("c3vgN")).then(() => parcelRequire('8iNv0'));